import {LinkText} from '@/components/atoms'
import {growthBookFeatureFlags} from '@/utils/constants/growthBookFeatureFlags'
import {useFeatureValue} from '@growthbook/growthbook-react'
import {DateTime} from 'luxon'

/**
 * Constants for PromotionList component
 */

/**
 * Column definitions for the sub-table (failed records)
 */
export const SUB_COLUMNS = [
  {
    columnKey: 'promotionName',
    header: 'PROMOTION NAME',
  },
  {
    columnKey: 'errorMessage',
    header: 'STATUS (REMARK)',
  },
]

/**
 * Column definitions for the main upload history table
 */
export const MAIN_COLUMNS = (downloadPromotionFile, downloadUploadError) => [
  {
    columnKey: 'fileName',
    header: 'FILE PATH',
    cellData: ({row: {original}}) => (
      <div
        className="flex w-[200px] flex-col whitespace-normal break-words"
        title={`${original?.storagePath}${original?.fileName}`}
      >
        <LinkText
          text={`${original?.storagePath}${original?.fileName}`}
          id={`${original?.storagePath}${original?.fileName}`}
          allowWrap={true}
          handleClick={event => {
            event.stopPropagation()
            downloadPromotionFile(original?.id)
          }}
        />
      </div>
    ),
  },
  {
    columnKey: 'uploadedAt',
    header: 'IMPORT DATE',
    cellData: ({row: {original}}) => {
      const formatted = ToFormattedDateTime(original?.uploadedAt)
      return <div>{formatted ?? '—'}</div>
    },
  },
  {
    columnKey: 'processingStartedAt',
    header: 'JOB START DATE',
    cellData: ({row: {original}}) => {
      const formatted = ToFormattedDateTime(original?.processingStartedAt)
      return <div>{formatted ?? '—'}</div>
    },
  },
  {
    columnKey: 'processingCompletedAt',
    header: 'JOB END DATE',
    cellData: ({row: {original}}) => {
      const formatted = ToFormattedDateTime(original?.processingCompletedAt)
      return <div>{formatted ?? '—'}</div>
    },
  },
  {
    columnKey: 'statistics',
    header: 'STATISTICS',
    cellData: ({row: {original}}) => (
      <div className="flex flex-col">
        {Number(original?.successfulRecords) > 0 && <div>{original?.successfulRecords} Records</div>}
        {Number(original?.failedRecords) > 0 && (
          <LinkText
            text={`${original?.failedRecords} Failed`}
            id={original?.failedRecords + ' ' + original?.fileUploadUUID}
            fontColor="#E46666"
            fontWeight="bold"
            handleClick={event => {
              event.stopPropagation()
              downloadUploadError(original?.id)
            }}
          />
        )}
        {Number(original?.successfulRecords) === 0 && Number(original?.failedRecords) === 0 && <div>{'—'}</div>}
      </div>
    ),
  },
  {
    columnKey: 'createdBy',
    header: 'UPLOADED BY',
    cellData: ({row: {original}}) => {
      return <div>{original?.uploadedBy ?? 'Unknown'}</div>
    },
  },
]

// ---------------------------------------------------------------------------
// Helpers
// ---------------------------------------------------------------------------

/**
 * Convert an ISO/UTC string to Mexico-City time string (handles DST)
 */

const MX_ZONE = 'America/Mexico_City'
const DATE_FMT = 'yyyy-MM-dd HH:mm:ss'
const ToFormattedDateTime = iso => {
  const timeZone = useFeatureValue(growthBookFeatureFlags.AdminTimezone)
  return iso
    ? DateTime.fromISO(iso, {zone: 'utc'})
        .setZone(timeZone ? timeZone : MX_ZONE)
        .toFormat(DATE_FMT)
    : null
}
